import { IGetAllNovosNegociosUseCase } from "../../../presentation/useCases/read/get_all_novos_negocios_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";
import { NovosNegociosLista } from "../../models/novos_negocios_lista";

/**
 * GetAllNovosNegociosUseCase
 */

export class GetAllNovosNegociosUseCase extends BasePaginatedUseCase<NovosNegociosLista> implements IGetAllNovosNegociosUseCase {
  constructor(private readonly repository: IComercialRepository) {
    super();
  }

  async execute(
    idsCliente: number[],
    cidade?: string,
    data?: Date,
    status?: number,

    currentPage?: number,
    rowsPerPage?: number
  ): Promise<void> {
    const result = await this.repository.getAllNovosNegociosLista(
      idsCliente,
      cidade,
      data,
      status,
      currentPage,
      rowsPerPage
    );

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;

  }
}
